import { Injectable } from '@angular/core';

import { ChartType } from '../apextypes';
import { IEventGroupBySettings } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class EventsByTypeWidgetService {
    areSettingsValid(settings: IEventGroupBySettings): boolean {
        if (!settings.remote) {
            return false;
        }
        if (!settings.remote.field_name) {
            return false;
        }
        if (!settings.remote.event_filter) {
            return false;
        }
        return true;
    }

    areRemoteSettingsEmpty(remoteSettings: any): boolean {
        if (!remoteSettings || Object.keys(remoteSettings).length === 0) {
            return true;
        }
        return false;
    }

    adjustHeight(chartType: ChartType, chartWidth: number, desiredHeight: number): number {
        // Setting height is a little bit more complicated
        // On square type of charts (donut), available height should not be more than the width
        let newHeight: number;
        if (chartType === 'donut') {
            newHeight = (chartWidth && desiredHeight > chartWidth) ? chartWidth : desiredHeight;
            const minDiff = 80;
            if (chartWidth && (chartWidth - newHeight) < minDiff) {
                newHeight = chartWidth - minDiff;
            }
        } else {
            newHeight = desiredHeight;
        }
        // The diff between width-height should not be less than 50
        return newHeight;
    }

    convertSeries(chartType: ChartType, series: number[]): ApexAxisChartSeries | ApexNonAxisChartSeries {
        if (!series) {
            series = [];
        }
        if (chartType === 'bar') {
            // Bar requires series in format { data: number[] }[]
            return [{ data: series }];
        } else if (chartType === 'donut') {
            // Donut requires series in format number[]
            return series;
        } else {
            return series;
        }
    }
}
